import TextStyle from '../../../styles/text';

export default {
    titleDialog: {
        ...TextStyle.modal_title,
        border: 'none',
        cursor: 'default',
        padding: '30px',
    },
    bodyStyle: {
        padding: '30px',
    },
    actions: {
        border: 'none',
        padding: '30px',
    },
};
